import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

const DatasourceConnectWise = (props) => {

    const Fields = [
        {Identifier:"Site", Translation:Translate("Site"), Required:true},
        {Identifier:"CompanyId", Translation:Translate("Company Id"), Required:true},
        {Identifier:"ApiPublicKey", Translation:Translate("API public key"), Required:true},
        {Identifier:"ApiPrivateKey", Translation:Translate("API private key"), Required:true}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceConnectWise.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceConnectWise